import { observer } from 'mobx-react-lite';
import { colors } from '../../../../colorVars';
import { useWebsocketStore } from '../../../../stores/websocketStore/websocketProvider';
import { Body3 } from '../../../atomic/text/Text';
import style from './SymbolsLeft.module.css';

export const SymbolsLeft = observer(() => {
  const { symbolsLeftStore } = useWebsocketStore();
  const symbolsUsed = symbolsLeftStore.symbolsUsed;
  let symbolColor = symbolsUsed > 1150 ? `${colors.red}` : `${colors.green}`;

  if (symbolsUsed >= 1250) {
    return (
      <div className={style.container}>
        <Body3 color={colors.red} fontWeight={700}>
          <h6>Max number of symbols used</h6>
        </Body3>
      </div>
    );
  } else {
    return (
      <div className={style.container}>
        <Body3 color={symbolColor} fontWeight={700}>
          {`Symbols Used: ${symbolsUsed}/1250`}
        </Body3>
      </div>
    );
  }
});
